
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const AddCupom = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CUPOM_ADD_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'CUPOM_ADD_ERROR':
            return { loading: false, error: true, data: [] };
        case 'CUPOM_ADD_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'CUPOM_ADD_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default AddCupom